import React from 'react';
import { OPT_OUT_LANGUAGE } from '../constants/AppConstants';

const OptOut = ({ className }) => (
  <div className={`${className || ''} u-p-t-small`}>
    {OPT_OUT_LANGUAGE}
  </div>
);
export default OptOut;
